(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["g-feature-zoom"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (!('customElements' in window) || customElements.get('g-feature-zoom')) return;

    const SVG_NS = 'http://www.w3.org/2000/svg';
    const ZOOM_MIN = 1;
    const ZOOM_MAX_DEFAULT = 6;
    const ZOOM_STEP = 0.1;
    const ANGLE_PER_UNIT = 16;
    const VIEW = 400;
    const CX = 200;
    const CY = 200;
    const TICK_R = 156;
    const MINOR_LEN = 8;
    const RIM_GAP = 8;
    const LABEL_SIZE_DESKTOP = 11;
    const LABEL_SIZE_MOBILE = 14;
    const LABEL_GAP = 3;
    const STEP_DEG = ZOOM_STEP * ANGLE_PER_UNIT;
    const TICK_COUNT = Math.round(360 / STEP_DEG);
    const FADE_SPAN = 88;
    const MINOR_WIDTH = 0.4;
    const MINOR_OPACITY = 0.48;
    const FAR_TICK_OPACITY = 0.28;
    const RIM_WIDTH = 1.15;
    const RIM_OPACITY = 0.55;
    const FAR_RIM_WIDTH = 0.28;
    const FAR_RIM_OPACITY = 0.14;
    const ZOOM_HOLD = 0.1;

    const reduceMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');

    const clamp = (value, min, max) => Math.min(max, Math.max(min, value));

    const formatZoom = (value, zoomMax) => String(clamp(Math.round(value), ZOOM_MIN, zoomMax));

    const wrap180 = (deg) => {
      let d = deg % 360;
      if (d > 180) d -= 360;
      if (d <= -180) d += 360;
      return d;
    };

    const lerp = (start, end, t) => start + (end - start) * clamp(t, 0, 1);

    const scaleOverflow = (angle, dir, scaleSpan) => {
      const a = wrap180(angle);
      const end = wrap180(dir * scaleSpan);
      const lo = Math.min(0, end);
      const hi = Math.max(0, end);
      if (a >= lo - 0.05 && a <= hi + 0.05) return 0;
      return Math.min(Math.abs(wrap180(a)), Math.abs(wrap180(a - end)));
    };

    const polar = (radius, deg) => {
      const rad = (deg * Math.PI) / 180;
      return [CX + radius * Math.sin(rad), CY - radius * Math.cos(rad)];
    };

    const arcPath = (radius, startDeg, endDeg) => {
      const [x1, y1] = polar(radius, startDeg);
      const [x2, y2] = polar(radius, endDeg);
      const delta = endDeg - startDeg;
      const large = Math.abs(delta) > 180 ? 1 : 0;
      const sweep = delta > 0 ? 1 : 0;
      return `M ${x1.toFixed(2)} ${y1.toFixed(2)} A ${radius} ${radius} 0 ${large} ${sweep} ${x2.toFixed(2)} ${y2.toFixed(2)}`;
    };

    const createSvgNode = (name, attrs = {}) => {
      const node = document.createElementNS(SVG_NS, name);
      Object.entries(attrs).forEach(([key, val]) => {
        if (val != null) node.setAttribute(key, String(val));
      });
      return node;
    };

    class GFeatureZoom extends HTMLElement {
      connectedCallback() {
        if (this._connected) return;
        this._connected = true;
        this.sticky = this.querySelector('[data-zoom-sticky]');
        this.media = this.querySelector('[data-zoom-media]');
        this.scaleEl = this.querySelector('[data-zoom-scale]');
        this.wheel = this.querySelector('[data-zoom-wheel]');
        this.valueEl = this.querySelector('[data-zoom-num]');
        this._ticks = [];
        this._labels = [];
        this._raf = 0;
        this._lastText = '';
        this._desktopQuery = window.matchMedia('(min-width: 769px)');
        this._dir = 1;
        this._zoomMax = this._readZoomMax();
        this._scaleSpan = (this._zoomMax - ZOOM_MIN) * ANGLE_PER_UNIT;
        this._onScroll = this._onScroll.bind(this);
        this._onResize = this._onResize.bind(this);
        this._onMotionChange = this._onMotionChange.bind(this);
        this._onBreakpoint = this._onBreakpoint.bind(this);
        this._fitStage = this._fitStage.bind(this);

        this._buildWheel();
        this._update(this._progress());
        this._observeStage();
        this._fitStage();

        window.addEventListener('scroll', this._onScroll, { passive: true });
        window.addEventListener('resize', this._onResize, { passive: true });
        if (typeof this._desktopQuery.addEventListener === 'function') {
          this._desktopQuery.addEventListener('change', this._onBreakpoint);
        } else if (typeof this._desktopQuery.addListener === 'function') {
          this._desktopQuery.addListener(this._onBreakpoint);
        }
        if (typeof reduceMotionQuery.addEventListener === 'function') {
          reduceMotionQuery.addEventListener('change', this._onMotionChange);
        } else if (typeof reduceMotionQuery.addListener === 'function') {
          reduceMotionQuery.addListener(this._onMotionChange);
        }
      }

      disconnectedCallback() {
        window.removeEventListener('scroll', this._onScroll);
        window.removeEventListener('resize', this._onResize);
        if (typeof this._desktopQuery.removeEventListener === 'function') {
          this._desktopQuery.removeEventListener('change', this._onBreakpoint);
        } else if (typeof this._desktopQuery.removeListener === 'function') {
          this._desktopQuery.removeListener(this._onBreakpoint);
        }
        if (typeof reduceMotionQuery.removeEventListener === 'function') {
          reduceMotionQuery.removeEventListener('change', this._onMotionChange);
        } else if (typeof reduceMotionQuery.removeListener === 'function') {
          reduceMotionQuery.removeListener(this._onMotionChange);
        }
        if (this._fitObserver) {
          this._fitObserver.disconnect();
          this._fitObserver = null;
        }
        if (this._raf) window.cancelAnimationFrame(this._raf);
        this._connected = false;
      }

      _readZoomMax() {
        const raw = Number(this.getAttribute('data-zoom-max'));
        if (!Number.isFinite(raw)) return ZOOM_MAX_DEFAULT;
        return clamp(raw, 2, 8);
      }

      _observeStage() {
        const wrap = this.querySelector('.g-feature-zoom__stage-wrap');
        const inner = this.querySelector('.g-feature-zoom__inner');
        if (!wrap || typeof ResizeObserver !== 'function') return;
        this._fitObserver = new ResizeObserver(this._fitStage);
        this._fitObserver.observe(wrap);
        if (inner) this._fitObserver.observe(inner);
      }

      _fitStage() {
        const wrap = this.querySelector('.g-feature-zoom__stage-wrap');
        if (!wrap) return;
        if (!this._desktopQuery.matches) {
          wrap.style.removeProperty('--g-feature-zoom-fit-h');
          return;
        }
        const height = wrap.clientHeight;
        if (height > 0) {
          wrap.style.setProperty('--g-feature-zoom-fit-h', `${height}px`);
        }
      }

      _buildWheel() {
        if (!this.wheel) return;
        this._dir = 1;
        this._ticks = [];
        this._labels = [];
        this.wheel.replaceChildren();

        const svg = createSvgNode('svg', {
          viewBox: `0 0 ${VIEW} ${VIEW}`,
          fill: 'none',
          'aria-hidden': 'true',
          focusable: 'false',
        });

        const rotating = createSvgNode('g', { 'data-zoom-rotating': '' });
        const dir = this._dir;
        const desktop = this._desktopQuery.matches;
        const labelSize = desktop ? LABEL_SIZE_DESKTOP : LABEL_SIZE_MOBILE;
        const rimR = desktop ? TICK_R - RIM_GAP : TICK_R + MINOR_LEN + RIM_GAP;
        const rimWidth = desktop ? 0.5 : RIM_WIDTH;
        const farRimWidth = desktop ? 0.16 : FAR_RIM_WIDTH;
        const labelR = desktop
          ? TICK_R + MINOR_LEN + labelSize + LABEL_GAP * 2
          : TICK_R - labelSize * 0.6 - LABEL_GAP;

        for (let i = 0; i < TICK_COUNT; i += 1) {
          const a0 = dir * i * STEP_DEG;
          const a1 = dir * (i + 1) * STEP_DEG;
          const t = scaleOverflow(a0, dir, this._scaleSpan) / FADE_SPAN;
          rotating.appendChild(
            createSvgNode('path', {
              d: arcPath(rimR, a0, a1),
              stroke: `rgba(255,255,255,${lerp(RIM_OPACITY, FAR_RIM_OPACITY, t).toFixed(3)})`,
              'stroke-width': lerp(rimWidth, farRimWidth, t).toFixed(2),
              'stroke-linecap': 'butt',
            })
          );
        }

        for (let i = 0; i < TICK_COUNT; i += 1) {
          const angle = dir * i * STEP_DEG;
          const overflow = scaleOverflow(angle, dir, this._scaleSpan);
          const inside = overflow < 0.05;
          const rounded = Math.round((ZOOM_MIN + i * ZOOM_STEP) * 10) / 10;
          const isMajor = inside && Math.abs(rounded - Math.round(rounded)) < 0.001;
          const isMid = inside && !isMajor && Math.round(rounded * 10) % 10 === 5;
          const length = MINOR_LEN;
          const width = isMajor ? 1.7 : isMid ? 1 : MINOR_WIDTH;
          const fade = overflow / FADE_SPAN;
          const opacity = inside
            ? isMajor || isMid
              ? 1
              : MINOR_OPACITY
            : lerp(MINOR_OPACITY, FAR_TICK_OPACITY, fade);
          const [x1, y1] = polar(TICK_R, angle);
          const [x2, y2] = polar(TICK_R + length, angle);
          const line = createSvgNode('line', {
            x1: x1.toFixed(2),
            y1: y1.toFixed(2),
            x2: x2.toFixed(2),
            y2: y2.toFixed(2),
            stroke: `rgba(255,255,255,${opacity.toFixed(3)})`,
            'stroke-width': String(width),
            'stroke-linecap': 'butt',
          });
          rotating.appendChild(line);
          this._ticks.push(line);

          if (isMajor) {
            const [tx, ty] = polar(labelR, angle);
            const text = createSvgNode('text', {
              x: tx.toFixed(2),
              y: ty.toFixed(2),
              fill: '#fff',
              'font-size': String(labelSize),
              'font-family': 'Poppins, sans-serif',
              'font-weight': '500',
              'text-anchor': 'middle',
              'dominant-baseline': 'middle',
              transform: `rotate(${angle} ${tx.toFixed(2)} ${ty.toFixed(2)})`,
            });
            text.textContent = String(Math.round(rounded));
            text.dataset.angle = String(angle);
            rotating.appendChild(text);
            this._labels.push(text);
          }
        }

        svg.append(rotating);
        this.wheel.appendChild(svg);
        this._rotating = rotating;
      }

      _progress() {
        if (reduceMotionQuery.matches) return 0;
        const viewport = window.innerHeight || 1;
        const rect = this.getBoundingClientRect();
        const total = Math.max(1, this.offsetHeight - viewport);
        return clamp(-rect.top / total, 0, 1);
      }

      _zoomFromProgress(progress) {
        const usable = 1 - ZOOM_HOLD * 2;
        const t = clamp((progress - ZOOM_HOLD) / usable, 0, 1);
        const raw = ZOOM_MIN + t * (this._zoomMax - ZOOM_MIN);
        return Math.round(raw * 10) / 10;
      }

      _update(progress) {
        const zoom = this._zoomFromProgress(progress);
        const rotate = -this._dir * (zoom - ZOOM_MIN) * ANGLE_PER_UNIT;
        if (this.scaleEl) {
          this.scaleEl.style.setProperty('--g-feature-zoom-scale', String(zoom));
        }
        if (this._rotating) {
          this._rotating.setAttribute('transform', `rotate(${rotate} ${CX} ${CY})`);
        }
        if (this._desktopQuery.matches && this._labels.length) {
          this._labels.forEach((label) => {
            const visual = wrap180(Number(label.dataset.angle || 0) + rotate);
            label.setAttribute('opacity', Math.abs(visual) < 6 ? '0' : '1');
          });
        }
        const text = formatZoom(zoom, this._zoomMax);
        if (this.valueEl && text !== this._lastText) {
          this.valueEl.textContent = text;
          this._lastText = text;
        }
      }

      _onScroll() {
        if (this._raf) return;
        this._raf = window.requestAnimationFrame(() => {
          this._raf = 0;
          this._update(this._progress());
        });
      }

      _onResize() {
        this._fitStage();
        this._update(this._progress());
      }

      _onBreakpoint() {
        this._buildWheel();
        this._fitStage();
        this._update(this._progress());
      }

      _onMotionChange() {
        this._update(this._progress());
      }
    }

    customElements.define('g-feature-zoom', GFeatureZoom);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["g-product-recommender"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const rootSelector = '[data-product-recommender-root]';
    const runtimeKey = 'GProductRecommenderRuntime';

    if (window[runtimeKey]) {
      window[runtimeKey].init(document);
      return;
    }

    const instances = new WeakMap();

    const getRoots = function (scope) {
      if (!scope) return [];

      const roots = [];
      if (scope.nodeType === 1 && scope.matches(rootSelector)) {
        roots.push(scope);
      }

      if (scope.querySelectorAll) {
        scope.querySelectorAll(rootSelector).forEach(function (root) {
          roots.push(root);
        });
      }

      return roots;
    };

    const initRoot = function (root) {
      if (!root || instances.has(root)) return;

      const selectors = Array.from(root.querySelectorAll('[data-product-recommender-selector]'));
      const resultPanels = Array.from(root.querySelectorAll('[data-product-recommender-result]'));
      const chartStatus = root.querySelector('[data-product-recommender-status]');
      const chartResults = Array.from(root.querySelectorAll('[data-product-recommender-chart-result]'));
      const reducedMotionQuery = window.matchMedia
        ? window.matchMedia('(prefers-reduced-motion: reduce)')
        : { matches: false };

      const mapping = [
        { row: 2, column: 0, cameras: '2 Cam', tier: 'BASIC' },
        { row: 1, column: 0, cameras: '2 Cam', tier: 'SMART AI' },
        { row: 0, column: 0, cameras: '2 Cam', tier: 'WHOLE-HOME' },
        { row: 2, column: 1, cameras: '4 Cam', tier: 'BASIC' },
        { row: 1, column: 1, cameras: '4 Cam', tier: 'SMART AI' },
        { row: 0, column: 1, cameras: '4 Cam', tier: 'WHOLE-HOME' },
        { row: 2, column: 2, cameras: '6 Cam', tier: 'BASIC' },
        { row: 1, column: 2, cameras: '6 Cam', tier: 'SMART AI' },
        { row: 0, column: 2, cameras: '6 Cam', tier: 'WHOLE-HOME' },
      ];

      const retryTimers = new Set();
      const swiperInstances = new Set();
      const buttonContent = new WeakMap();
      let chartFrame = null;
      let resizeFrame = null;
      let destroyed = false;

      const getSelector = function (key) {
        return selectors.find(function (selector) {
          return selector.dataset.selectorKey === key;
        });
      };

      const getActiveOptionIndex = function (selector) {
        if (!selector) return 0;

        const activeOption = selector.querySelector('[data-product-recommender-option].is-active');
        const activeIndex = activeOption ? parseInt(activeOption.dataset.optionIndex, 10) : 0;
        return Number.isNaN(activeIndex) ? 0 : activeIndex;
      };

      const updateSelectorSlider = function (selector, animate) {
        if (!selector) return;

        const slider = selector.querySelector('[data-product-recommender-selector-slider]');
        const activeOption = selector.querySelector('[data-product-recommender-option].is-active');
        if (!slider || !activeOption) return;

        if (!animate || reducedMotionQuery.matches) {
          slider.style.transition = 'none';
        }

        slider.style.width = activeOption.offsetWidth + 'px';
        slider.style.transform = 'translate3d(' + activeOption.offsetLeft + 'px, 0, 0)';

        if (!animate || reducedMotionQuery.matches) {
          slider.getBoundingClientRect();
          slider.style.transition = reducedMotionQuery.matches ? 'none' : '';
        }
      };

      const setActiveOption = function (selector, option, animate) {
        if (!selector || !option) return;

        selector.querySelectorAll('[data-product-recommender-option]').forEach(function (candidate) {
          const isActive = candidate === option;
          candidate.classList.toggle('is-active', isActive);
          candidate.setAttribute('aria-pressed', isActive ? 'true' : 'false');
        });

        const copy = selector.querySelector('[data-product-recommender-selector-copy]');
        const description = option.dataset.description || '';
        if (copy) {
          copy.textContent = description;
          copy.hidden = description === '';
        }

        updateSelectorSlider(selector, animate);
      };

      const initSelectors = function () {
        selectors.forEach(function (selector) {
          const options = Array.from(selector.querySelectorAll('[data-product-recommender-option]'));
          if (options.length === 0) return;

          const defaultOptionIndex = Math.max(0, parseInt(selector.dataset.defaultOption || '1', 10) - 1);
          const defaultOption =
            options.find(function (option) {
              return parseInt(option.dataset.optionIndex, 10) === defaultOptionIndex;
            }) || options[0];

          setActiveOption(selector, defaultOption, false);
        });
      };

      const initProductSlider = function (panel, attempt) {
        if (!panel || panel.hidden || destroyed) return;

        const productCount = parseInt(panel.dataset.productCount || '0', 10);
        const slider = panel.querySelector('[data-product-recommender-swiper]');
        if (!slider || productCount <= 1) return;

        if (slider.productRecommenderSwiper && !slider.productRecommenderSwiper.destroyed) {
          slider.productRecommenderSwiper.update();
          slider.productRecommenderSwiper.slideTo(0, 0);
          return;
        }

        if (!window.Swiper) {
          if (attempt >= 50) return;

          const timer = window.setTimeout(function () {
            retryTimers.delete(timer);
            initProductSlider(panel, attempt + 1);
          }, 100);
          retryTimers.add(timer);
          return;
        }

        const prevButton = panel.querySelector('[data-product-recommender-prev]');
        const nextButton = panel.querySelector('[data-product-recommender-next]');
        const pagination = panel.querySelector('[data-product-recommender-pagination]');

        const swiper = new window.Swiper(slider, {
          slidesPerView: 1,
          slidesPerGroup: 1,
          spaceBetween: 20,
          speed: reducedMotionQuery.matches ? 0 : 420,
          threshold: 8,
          watchOverflow: true,
          observer: true,
          observeParents: true,
          preventClicks: true,
          preventClicksPropagation: true,
          noSwipingClass: 'swiper-no-swiping',
          navigation: {
            prevEl: prevButton,
            nextEl: nextButton,
          },
          pagination: {
            el: pagination,
            clickable: true,
          },
        });

        slider.productRecommenderSwiper = swiper;
        swiperInstances.add(swiper);
      };

      const showResultPanel = function (resultIndex) {
        let activePanel = null;

        resultPanels.forEach(function (panel) {
          const isActive = parseInt(panel.dataset.productRecommenderResult, 10) === resultIndex;
          panel.hidden = !isActive;
          panel.classList.toggle('is-active', isActive);

          if (isActive) activePanel = panel;
        });

        if (!activePanel) return;

        activePanel.classList.add('is-entering');
        activePanel.getBoundingClientRect();

        window.requestAnimationFrame(function () {
          if (destroyed) return;
          activePanel.classList.remove('is-entering');
          initProductSlider(activePanel, 0);
        });
      };

      const render = function () {
        const coverageIndex = getActiveOptionIndex(getSelector('coverage'));
        const featureIndex = getActiveOptionIndex(getSelector('feature'));
        const resultIndex = coverageIndex * 3 + featureIndex + 1;
        const result = mapping[resultIndex - 1] || mapping[0];

        if (chartFrame !== null) {
          window.cancelAnimationFrame(chartFrame);
          chartFrame = null;
        }

        chartResults.forEach(function (chartResult) {
          chartResult.classList.remove('is-active');
          const primary = chartResult.querySelector('[data-product-recommender-chart-primary]');
          const secondary = chartResult.querySelector('[data-product-recommender-chart-secondary]');
          if (primary) primary.textContent = '';
          if (secondary) secondary.textContent = '';
        });

        const activeChartResult = chartResults.find(function (chartResult) {
          return (
            parseInt(chartResult.dataset.row, 10) === result.row &&
            parseInt(chartResult.dataset.column, 10) === result.column
          );
        });

        if (activeChartResult) {
          const primary = activeChartResult.querySelector('[data-product-recommender-chart-primary]');
          const secondary = activeChartResult.querySelector('[data-product-recommender-chart-secondary]');
          if (primary) primary.textContent = result.cameras;
          if (secondary) secondary.textContent = result.tier;

          chartFrame = window.requestAnimationFrame(function () {
            chartFrame = null;
            if (!destroyed) activeChartResult.classList.add('is-active');
          });
        }

        if (chartStatus) chartStatus.textContent = result.cameras + ', ' + result.tier;
        showResultPanel(resultIndex);
      };

      const requestAddToCart = async function (variantId, quantity) {
        if (!window.Shopify || !window.Shopify.routes || !window.Shopify.routes.root) {
          throw new Error('Shopify routes unavailable');
        }

        const sectionsToBundle = ['variant-added'];
        document.documentElement.dispatchEvent(
          new CustomEvent('cart:prepare-bundled-sections', {
            bubbles: true,
            detail: { sections: sectionsToBundle },
          })
        );

        const formData = new FormData();
        formData.set('id', variantId);
        formData.set('quantity', quantity);
        formData.set('sections', sectionsToBundle.join(','));
        formData.set('sections_url', window.Shopify.routes.root + 'variants/' + variantId);

        const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
          body: formData,
          method: 'POST',
          headers: { 'X-Requested-With': 'XMLHttpRequest' },
        });

        const responseJson = await response.json();
        if (!response.ok) throw new Error(responseJson.description || 'Add to cart failed');

        const cartResponse = await fetch(window.Shopify.routes.root + 'cart.js');
        const cartContent = await cartResponse.json();
        cartContent.sections = responseJson.sections;

        document.dispatchEvent(
          new CustomEvent('variant:add', {
            bubbles: true,
            detail: {
              items: Object.prototype.hasOwnProperty.call(responseJson, 'items') ? responseJson.items : [responseJson],
              cart: cartContent,
            },
          })
        );

        document.documentElement.dispatchEvent(
          new CustomEvent('cart:change', {
            bubbles: true,
            detail: { baseEvent: 'variant:add', cart: cartContent },
          })
        );

        return cartContent;
      };

      const setButtonLoading = function (button, loading) {
        if (loading) {
          if (button.dataset.loading === 'true') return false;

          buttonContent.set(button, button.innerHTML);
          button.dataset.loading = 'true';
          button.classList.add('is-loading');
          button.setAttribute('aria-busy', 'true');
          button.disabled = true;
          button.innerHTML = '<span class="g-product-recommender__spinner" aria-hidden="true"></span>';
          return true;
        }

        button.dataset.loading = 'false';
        button.classList.remove('is-loading');
        button.removeAttribute('aria-busy');
        button.disabled = false;

        if (buttonContent.has(button)) button.innerHTML = buttonContent.get(button);
        return true;
      };

      const handleAddToCart = async function (button) {
        const variantId = button.dataset.variantId;
        if (!variantId || button.dataset.loading === 'true' || button.disabled) return;
        if (!setButtonLoading(button, true)) return;

        try {
          await requestAddToCart(variantId, 1);
        } catch (error) {
          console.error('G Product Recommender add to cart failed:', error);
          document.dispatchEvent(
            new CustomEvent('cart:error', {
              bubbles: true,
              detail: { error: error.message },
            })
          );
        } finally {
          setButtonLoading(button, false);
        }
      };

      const handleRootClick = function (event) {
        const option = event.target.closest('[data-product-recommender-option]');
        if (option && root.contains(option)) {
          const selector = option.closest('[data-product-recommender-selector]');
          if (!selector || option.classList.contains('is-active')) return;

          setActiveOption(selector, option, true);
          render();
          return;
        }

        const addToCartButton = event.target.closest('[data-product-recommender-add-to-cart]');
        if (!addToCartButton || !root.contains(addToCartButton)) return;

        event.preventDefault();
        event.stopPropagation();
        handleAddToCart(addToCartButton);
      };

      const handleResize = function () {
        if (resizeFrame !== null) window.cancelAnimationFrame(resizeFrame);

        resizeFrame = window.requestAnimationFrame(function () {
          resizeFrame = null;
          selectors.forEach(function (selector) {
            updateSelectorSlider(selector, false);
          });

          swiperInstances.forEach(function (swiper) {
            if (!swiper.destroyed) swiper.update();
          });
        });
      };

      const destroy = function () {
        if (destroyed) return;
        destroyed = true;

        root.removeEventListener('click', handleRootClick);
        window.removeEventListener('resize', handleResize);

        if (resizeFrame !== null) window.cancelAnimationFrame(resizeFrame);
        if (chartFrame !== null) window.cancelAnimationFrame(chartFrame);

        retryTimers.forEach(function (timer) {
          window.clearTimeout(timer);
        });
        retryTimers.clear();

        swiperInstances.forEach(function (swiper) {
          if (!swiper.destroyed) swiper.destroy(true, true);
        });
        swiperInstances.clear();

        root.removeAttribute('data-product-recommender-ready');
        instances.delete(root);
      };

      instances.set(root, { destroy: destroy });
      root.setAttribute('data-product-recommender-ready', 'true');

      initSelectors();
      render();

      root.addEventListener('click', handleRootClick);
      window.addEventListener('resize', handleResize);

      if (document.fonts && document.fonts.ready) {
        document.fonts.ready.then(function () {
          if (!destroyed && root.isConnected) handleResize();
        });
      }
    };

    const init = function (scope) {
      getRoots(scope).forEach(initRoot);
    };

    const destroy = function (scope) {
      getRoots(scope).forEach(function (root) {
        const instance = instances.get(root);
        if (instance) instance.destroy();
      });
    };

    document.addEventListener('shopify:section:load', function (event) {
      init(event.target);
    });

    document.addEventListener('shopify:section:unload', function (event) {
      destroy(event.target);
    });

    window[runtimeKey] = {
      init: init,
      destroy: destroy,
    };

    if (document.readyState === 'loading') {
      document.addEventListener(
        'DOMContentLoaded',
        function () {
          init(document);
        },
        { once: true }
      );
    } else {
      init(document);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  window.addEventListener('load', function() {
    let button = document.getElementsByClassName("close-button");
    if (button && button.length > 0) {
      button[button.length - 1].addEventListener("click", () => {
        if (button[button.length - 1].parentNode) {
          button[button.length - 1].parentNode.style.display = "none";
        }
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["star-product-title"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    if(document.querySelectorAll('.popup-button-link').length > 0){
        const popupButton = document.querySelector('.popup-button-link');
        const popupButtonWrapper = document.querySelector('.popup-button-wrapper');
        const popupCloseButton = document.querySelector('.popup-close-button');

        popupButton.addEventListener('click', function() {
          popupButtonWrapper.style.display = 'block';
          document.body.classList.add('overflow-hidden');
        });

        popupCloseButton.addEventListener('click', function() {
          popupButtonWrapper.style.display = 'none';
          document.body.classList.remove('overflow-hidden');
        });

        popupButtonWrapper.addEventListener('click', function(e) {
          if(!e.target.classList.contains('popup-button-popup-content') && !e.target.closest('.popup-button-popup-content')){
            popupButtonWrapper.style.display = 'none';
            document.body.classList.remove('overflow-hidden');
          }
        });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tabs"] && !Shopify.designMode) return;
  try {
    
  window.addEventListener('load', function() {
    const looks = document.querySelectorAll(".shopify-section--shop-the-look");
    for(let i = 0; i < looks.length; i++){
      if(i === 0) {
        looks[i].style.display = "block";
      }else {
        looks[i].style.display = "none";
      }
    }

    const btns = document.querySelectorAll(".tabs-nav__button");
    for(let j = 0; j < btns.length; j++){
      btns[j].index = j;
      btns[j].onclick = function () {
        for(let i = 0; i < looks.length; i++){
          if(i === this.index) {
            looks[i].style.display = "block";
          }else {
            looks[i].style.display = "none";
          }
        }
      }
    }

    const s_btns = document.querySelectorAll(".accordion");
    for(let k = 0; k < s_btns.length; k++){
      s_btns[k].removeAttribute("open");
      s_btns[k].setAttribute("aria-expanded", false);
      s_btns[k].index = k;
      s_btns[k].onclick = function () {
        for(let i = 0; i < looks.length; i++){
          if(i === this.index) {
            looks[i].style.display = "block";
            this.removeAttribute("open");
            this.setAttribute("aria-expanded", false);
          }else {
            looks[i].style.display = "none";
            this.removeAttribute("open");
            this.setAttribute("aria-expanded", false);
          }
        }
      }
    }
  });

  } catch(e) { console.error(e); }
})();
})();
